/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ConvertForDataTestPipe } from '@common/tech-shared';
import { Component, inject, InputSignal, input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { CheckboxComponent, IconComponent, TooltipDirective } from '@ods/system';
import { UserFormService } from '../../user.formservice';

@Component({
  selector: 'administration-role-checkbox',
  imports: [TooltipDirective, IconComponent, CheckboxComponent, ConvertForDataTestPipe],
  templateUrl: './role-checkbox.component.html',
})
export class RoleCheckboxComponent {
  private readonly formService: UserFormService = inject(UserFormService);

  public readonly role: InputSignal<AbstractControl> = input.required<AbstractControl>();
  public readonly isAlfaRole: InputSignal<boolean> = input<boolean>(false);

  public get label(): string {
    return this.formService.getRoleLabel(this.role());
  }

  public get description(): string {
    return this.formService.getRoleDescription(this.role());
  }

  public get checkedControl(): FormControl {
    return this.formService.getCheckedControl(this.role());
  }

  public get disabled(): boolean {
    return this.isAlfaRole() && this.formService.isAlfaRoleDisabled(this.role());
  }
}
